import { render } from "./CharacterDisplay.vue?vue&type=template&id=0887b64e&scoped=true"
import script from "./CharacterDisplay.vue?vue&type=script&lang=js"
export * from "./CharacterDisplay.vue?vue&type=script&lang=js"

import "./CharacterDisplay.vue?vue&type=style&index=0&id=0887b64e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0887b64e"]])

export default __exports__